import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { CategoriesComponent } from './pages/categories/categories.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { EditCategoryComponent } from './pages/edit-category/edit-category.component';
import { EditNewsComponent } from './pages/edit-news/edit-news.component';
import { EditProductComponent } from './pages/edit-product/edit-product.component';
import { LoginComponent } from './pages/login/login.component';
import { NewsComponent } from './pages/news/news.component';
import { OrderDetailComponent } from './pages/order-detail/order-detail.component';
import { OrdersComponent } from './pages/orders/orders.component';
import { ProductsComponent } from './pages/products/products.component';
import { UserDetatailComponent } from './pages/user-detail/user-detail.component';
import { UsersComponent } from './pages/users/users.component';
import { StoresComponent } from './pages/stores/stores/stores.component';
import { SliderComponent } from './pages/slider/slider.component';
import { EditStoreComponent } from './pages/stores/edit-store/edit-store.component';
import { StorePromotionsComponent } from './pages/stores/store-promotions/store-promotions.component';
import { MkoPushesComponent } from './pages/mko-pushes/mko-pushes.component';
import { BartendersComponent } from './pages/bartenders/bartenders/bartenders.component';
import { EditBartenderComponent } from './pages/bartenders/edit-bartender/edit-bartender.component';
import { ProductLinksComponent } from './pages/product-links/product-links.component';
import { CitiesComponent } from './pages/city/cities/cities.component';
import { EditCityComponent } from './pages/city/edit-city/edit-city.component';
import { ProductsSortComponent } from './pages/products-sort/products-sort.component';
import { FilterSortComponent } from './pages/filter-sort/filter-sort.component';
import { ListStoriesComponent } from './pages/story/list-stories/list-stories.component';
import { EditStoryComponent } from './pages/story/edit-story/edit-story.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'categories', component: CategoriesComponent, canActivate: [AuthGuard] },
  { path: 'categories/edit/:id', component: EditCategoryComponent, canActivate: [AuthGuard] },
  { path: 'products/edit/:id', component: EditProductComponent, canActivate: [AuthGuard] },
  { path: 'products', component: ProductsComponent, canActivate: [AuthGuard] },
  { path: 'orders', component: OrdersComponent, canActivate: [AuthGuard] },
  { path: 'orders/view/:id', component: OrderDetailComponent, canActivate: [AuthGuard] },
  { path: 'users', component: UsersComponent, canActivate: [AuthGuard] },
  { path: 'users/edit/:id', component: UserDetatailComponent, canActivate: [AuthGuard] },
  { path: 'news', component: NewsComponent, canActivate: [AuthGuard] },
  { path: 'news/edit/:id', component: EditNewsComponent, canActivate: [AuthGuard] },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'push', component: MkoPushesComponent, canActivate: [AuthGuard] },
  { path: 'stores/list', component: StoresComponent, canActivate: [AuthGuard] },
  { path: 'stores/list/edit/:id', component: EditStoreComponent, canActivate: [AuthGuard] },
  { path: 'bartenders', component: BartendersComponent, canActivate: [AuthGuard] },
  { path: 'bartenders/edit/:id', component: EditBartenderComponent, canActivate: [AuthGuard] },
  { path: 'slider', component: SliderComponent, canActivate: [AuthGuard] },
  { path: 'stores/promotions', component: StorePromotionsComponent, canActivate: [AuthGuard] },
  { path: 'products/links', component: ProductLinksComponent, canActivate: [AuthGuard] },
  { path: 'cities', component: CitiesComponent, canActivate: [AuthGuard] },
  { path: 'cities/edit/:id', component: EditCityComponent, canActivate: [AuthGuard] },
  { path: 'products/sort', component: CategoriesComponent, canActivate: [AuthGuard] },
  { path: 'products/sort/:id', component: ProductsSortComponent, canActivate: [AuthGuard] },
  { path: 'products/sort/:id', component: ProductsSortComponent, canActivate: [AuthGuard] },

  {
    path: 'products/filters', component: CategoriesComponent, canActivate: [AuthGuard],
    data: {
      'baseUrl': '/products/filters'
    }
  },
  { path: 'products/filters/:id', component: FilterSortComponent, canActivate: [AuthGuard] },
  { path: 'stories', component: ListStoriesComponent, canActivate: [AuthGuard] },
  { path: 'stories/edit/:id', component: EditStoryComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
